import { render, staticRenderFns } from "./XProfitTourComponent.vue?vue&type=template&id=c66ab7b6&scoped=true&lang=pug"
import script from "./XProfitTourComponent.vue?vue&type=script&lang=js"
export * from "./XProfitTourComponent.vue?vue&type=script&lang=js"
import style0 from "./XProfitTourComponent.vue?vue&type=style&index=0&id=c66ab7b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66ab7b6",
  null
  
)

export default component.exports